import { ajaxPromise, displayNotification, htmlEsc, logerror } from './utils';

export function loadImportPreview(args: {
    prefix: string;
    uploadResponse: any;
    existingTable: DataTables.Api | null;
    showPreview: () => void;
}): DataTables.Api | null {
    const { prefix, uploadResponse, showPreview } = args;
    let { existingTable } = args;
    const { preview, previewHeaders, msgs: errors } = uploadResponse || {};

    $(`#${prefix}_upload_section`).find('.alert-danger').remove();

    if (errors && errors.length > 0) {
        let errorHtml = '<div class="alert alert-danger"><strong>Upload failed with the following errors:</strong><ul>';
        errors.forEach((error: any) => {
            const errorMessage = Array.isArray(error) ? error[1] : error;
            errorHtml += `<li>${htmlEsc(errorMessage)}</li>`;
        });
        errorHtml += '</ul></div>';
        $(`#${prefix}_upload_section`).find('.panel-body').prepend(errorHtml);
        return existingTable;
    }

    if (!preview || !previewHeaders) {
        return existingTable;
    }

    const hasErrors = preview.length === 0 || preview.some((row: any) => row.errors && row.errors.length > 0);
    $(`#${prefix}_discard`).prop('disabled', false);
    $(`#${prefix}_commit`).prop('disabled', hasErrors);

    const columns: DataTables.ColumnSettings[] = [
        {
            title: 'Row #',
            data: 'num',
            width: '60px',
        },
        {
            title: 'Status',
            name: 'Status',
            width: '180px',
            data: (row) => {
                const rowHasErrors = row.errors && row.errors.length > 0;
                const hasWarnings = row.warnings && row.warnings.length > 0;

                if (rowHasErrors) {
                    return `
                        <div>
                            <span class="label label-danger">${row.flair}</span>
                            <br>
                            <a href="#" class="view-row-issues" style="color: #fff; text-decoration: underline;"
                               data-row-num="${row.num}">
                                <i class="fa fa-exclamation-triangle"></i> ${row.errors.length} error${row.errors.length > 1 ? 's' : ''}
                            </a>
                            ${hasWarnings ? `<br><a href="#" class="view-row-issues" style="color: #fff; text-decoration: underline;" data-row-num="${row.num}">
                                <i class="fa fa-exclamation-circle"></i> ${row.warnings.length} warning${row.warnings.length > 1 ? 's' : ''}
                            </a>` : ''}
                        </div>
                    `;
                }

                if (hasWarnings) {
                    return `
                        <div>
                            <span class="label" style="background-color: #ffeb3b; color: #333;">${row.flair}</span>
                            <br>
                            <a href="#" class="view-row-issues" style="color: #fff; text-decoration: underline;"
                               data-row-num="${row.num}">
                                <i class="fa fa-exclamation-circle"></i> ${row.warnings.length} warning${row.warnings.length > 1 ? 's' : ''}
                            </a>
                        </div>
                    `;
                }

                return `<span class="label label-success">${row.flair}</span>`;
            },
        },
    ];

    previewHeaders.forEach((header: string, i: number) => {
        columns.push({
            title: htmlEsc(header),
            name: header,
            data: (row: any) => row.row?.[i] || '',
            render: (val: string, type: string) => {
                if (type === 'display' && val && val.length > 50) {
                    const truncated = val.substring(0, 50) + '...';
                    const escaped = htmlEsc(truncated);
                    const encodedFullText = encodeURIComponent(val);
                    return `<span class="import-longtext-cell" data-full-text="${encodedFullText}" data-title="${encodeURIComponent(header)}" style="cursor: pointer; text-decoration: underline; color: #222; text-shadow: 0 0.5px 0 rgba(255,255,255,0.7);">${escaped}</span>`;
                }
                return htmlEsc(val);
            },
        });
    });

    if (existingTable) {
        existingTable.destroy();
    }

    const $table = $(`#${prefix}_preview_table`);
    $table.off('click', '.import-longtext-cell');
    $table.off('click', '.view-row-issues');

    // The preview section starts hidden. scrollX copies the header into its own
    // table and sizes both from the container, so the section has to be visible first.
    showPreview();

    existingTable = $table
        .on('click', '.import-longtext-cell', function() {
            const $cell = $(this);
            const encodedText = $cell.attr('data-full-text') || '';
            const fullText = decodeURIComponent(encodedText);
            const title = decodeURIComponent($cell.attr('data-title') || '');
            $('#import_field_text_modal_label').text(title);
            $('#import_field_text_modal_content').text(fullText);
            $('#import_field_text_modal').modal('show');
        })
        .DataTable({
            data: preview,
            columns: columns,
            ajax: undefined,
            processing: true,
            serverSide: false,
            // The default responsive mode hides columns in a child row that does not show validation.
            responsive: false,
            scrollX: true,
            scrollCollapse: true,
            pageLength: 10,
            order: [[0, 'asc']],
            initComplete: function() {
                const api = (this as any).api() as DataTables.Api;
                const $wrapper = $(`#${prefix}_preview_table_wrapper`);
                const $scrollBody = $wrapper.find('.dataTables_scrollBody');
                const $scroll = $wrapper.find('.dataTables_scroll');

                if ($scrollBody.length && $scroll.length) {
                    $wrapper.find('.doubleScroll-scroll-wrapper').remove();

                    setTimeout(() => {
                        $scrollBody.doubleScroll({
                            $insertBefore: $scroll,
                            resetOnWindowResize: true
                        });
                        api.columns.adjust();
                    }, 100);
                } else {
                    api.columns.adjust();
                }
            },
            drawCallback: function () {
                const previewTable = (this as any).api() as DataTables.Api;
                previewTable.rows().every(function () {
                    const data = this.data() as any;
                    const $tr = $(this.node());
                    const bgColor = {
                        'new': 'success',
                        'Updated': 'primary',
                        'Error': 'danger',
                        'error': 'danger',
                        'Disabled': 'warning',
                    };
                    const color = bgColor[data.flair] || bgColor[data.flair.toLowerCase()] || 'info';
                    $tr.addClass(`bg-${color}`);
                });
            },
        });

    $table.on('click', '.view-row-issues', function(e) {
        e.preventDefault();
        const rowNum = $(this).data('row-num');
        const rowData = preview.find((r: any) => r.num === rowNum);

        if (rowData) {
            let issuesHtml = '';

            if (rowData.errors && rowData.errors.length > 0) {
                issuesHtml += '<h5 class="text-danger"><i class="fa fa-exclamation-triangle"></i> Errors</h5>';
                issuesHtml += '<ul class="list-unstyled">';
                rowData.errors.forEach((error: string) => {
                    issuesHtml += `<li><i class="fa fa-times-circle text-danger"></i> ${htmlEsc(error)}</li>`;
                });
                issuesHtml += '</ul>';
            }

            if (rowData.warnings && rowData.warnings.length > 0) {
                if (issuesHtml) issuesHtml += '<hr>';
                issuesHtml += '<h5 class="text-warning"><i class="fa fa-exclamation-circle"></i> Warnings</h5>';
                issuesHtml += '<ul class="list-unstyled">';
                rowData.warnings.forEach((warning: string) => {
                    issuesHtml += `<li><i class="fa fa-info-circle text-warning"></i> ${htmlEsc(warning)}</li>`;
                });
                issuesHtml += '</ul>';
            }

            const title = (rowData.errors && rowData.errors.length > 0) ?
                `Row ${rowNum} - Errors${rowData.warnings && rowData.warnings.length > 0 ? ' & Warnings' : ''}` :
                `Row ${rowNum} - Warnings`;

            $('#row_errors_modal_title').text(title);
            $('#row_errors_modal_body').html(issuesHtml);
            $('#row_errors_modal').modal('show');
        }
    });

    return existingTable;
}

/** Poll until a queued import finishes, fails, or has been waited on for half an hour. */
export async function watchQueuedImport(guid: string): Promise<{ state: 'done' | 'failed' | 'waiting'; msg: string }> {
    const started = Date.now();
    const limit = 30 * 60 * 1000;

    while (Date.now() - started < limit) {
        const response = await ajaxPromise('/import/status', { guid });
        if (response.rc !== 'OK') {
            return { state: 'failed', msg: response.msg || response.message || 'Could not check the import.' };
        }
        if (response.state === 'done') {
            return { state: 'done', msg: response.msg || '' };
        }
        if (response.state === 'failed') {
            return { state: 'failed', msg: response.msg || 'The import failed.' };
        }
        await new Promise((resolve) => setTimeout(resolve, 3000));
    }

    return {
        state: 'waiting',
        msg: 'The import is still running. Leave this page and come back to see if it has finished, or check Import History.',
    };
}

/** If this user already has a queued import, show it and keep polling after they return. */
export async function resumeQueuedImport(prefix: string, type: string, doneText: string) {
    const $banner = $(`#${prefix}_active_import`);
    const $text = $(`#${prefix}_active_import_text`);
    const $icon = $banner.find('i');

    const show = (message: string, spinning: boolean) => {
        $text.text(message);
        $icon.toggleClass('fa-spinner fa-spin', spinning).toggleClass('fa-info-circle', !spinning);
        $banner.show();
    };

    try {
        while (true) {
            const active = await ajaxPromise('/import/active', { type });
            if (active.rc !== 'OK' || !active.guid) {
                $banner.hide();
                return;
            }

            const name = active.filename ? ` (${active.filename})` : '';
            const more = active.queued_count > 1 ? ` ${active.queued_count} imports are queued.` : '';
            show(`An import is queued${name}.${more} This page will update when it finishes.`, true);

            const result = await watchQueuedImport(active.guid);
            if (result.state === 'done') {
                displayNotification('Import Complete', doneText, 'success');
                continue;
            }
            if (result.state === 'failed') {
                displayNotification('Import Failed', result.msg, 'danger');
                continue;
            }
            show(result.msg, false);
            return;
        }
    } catch (error) {
        logerror('resume queued import', error);
    }
}
